import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const dynamicTaskConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default dynamicTaskConfig;
